import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import { message } from "antd";
import * as services from "../services/warehouse";

class Stock {
  @observable isLoading = false;
  @observable tableData = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };
  @observable PageTopInfo = { pageIndex: 1, pageSize: 10 };
  @observable SearchPageInfo = { pageIndex: 1, pageSize: 10 };
  @observable formData = {};
  @observable searchData = "";
  @observable modalVisible = false;
  @observable masterData = []; // 获取的物料数据
  @observable supplierData = []; // 获取的供应商数据
  @observable warehouseData = []; // 获取的库位数据
  @observable clientData = []; // 获取的客户数据
  @observable tableWarehouseData = []; // 获取的客户数据
  @observable currentMaterial = "";
  @observable currentSupplier = "";
  @observable currentWarehouse = "";
  @observable currentClient = "";
  @observable Tabs = "";
  @observable searchMaterialId = "";
  @observable searchMaterialName=''
  @observable searchSupplierId = "";
  @observable searchLocationNo = "";
  @observable searchClientId = "";
  @observable searchOrigin = "";
  @observable searchStartDate = "";
  @observable searchEndDate = "";
  @observable pullBack = "";
  @observable searchPlanNo = ""
  @observable searchColor = ""
  @observable locationNo = "" //用于成品入库详情切页是传库位
  @observable planNo = "" //用于成品入库详情切页是传库位
  @observable businessType= "" //业务类型的存储

  @observable type = 0; //设置对应页面展示的结果
  @observable tableDetailData = []; //详情信息

  @observable packageCodeData = {}; //根据入库条码获取到的信息
  @observable packageCodeDetailList = []; //包装条码信息
  @observable planNoData={} //根据生产计划号获取相关信息
  @observable selectedRowKeys = [];
  @observable selectedRows = [];
  @observable HouseList= [];
  @observable oldFinishData = {};
  @observable MenuPermissions=[] //菜单权限
  @observable printModalVis = false; //打印页面展示
  @observable printData = [];
  @observable printSumData = "";

  @action async getMaster(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getMaster,
        params
      );
      if (isDataExist(res)) {
        this.masterData = res.data.data.items;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getSupplier(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getSupplier,
        params
      );
      if (isDataExist(res)) {
        this.supplierData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getWarehouse(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getWarehouse,
        params
      );
      if (isDataExist(res)) {
        this.warehouseData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

//tab页权限按钮
@action async getTreeMenu(params){

  this.MenuPermissions=[]
  try{
 let res=await services.getRequest(
     services.requestUrl.treeMenu,
     params
 );
 if(isDataExist(res)){
  res.data.data.childMenu.map(item=>{
    if(item.name==='特殊权限'){
      item.childMenu.map(item=>{
        this.MenuPermissions.push(item.name)
      })
    }
  })
 }
  }catch(error){
    console.log(error)
  }
}


  //只有原材料库的库位
  @action async getWarehouseType(params){
    try{
 let res=await services.getRequest(
      services.requestUrl.WarehouseType,
      params
 );
 if(isDataExist(res)){
   this.warehouseData=res.data.data
 }
    }catch(error){
      console.log(error);
    }
  }

  @action async getClient(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getClient,
        params
      );
      if (isDataExist(res)) {
        this.clientData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
@action async getWareHouseType(params){
  try{
     let res=await services.getRequest(
       services.requestUrl.wareHouseList,
       params
     );
     if(isDataExist(res)){
      this.HouseList=res.data.data.items
     }
  }catch(error){
    console.log(error)
  }
}

//成品入库列表主页面
@action async getListWithGroup(params){
  this.isLoading=true
  try{
    const url=services.requestUrl.getListWithGroup;
    let res=await services.getRequest(url,{...params,...this.SearchPageInfo});
    if(isDataExist(res)){
      this.isLoading=false
    res.data.data.items.map(item=>{
    item.locationNo=item.warehouseDo&&item.warehouseDo.locationNo||''
    item.fullName=item.supplier&&item.supplier.fullName||''
    item.fullName1=item.client&&item.client.fullName||''
    item.planNo=item.productPlan&&item.productPlan.planNo||''
    item.name=item.material&&item.material.name||''
    item.color=item.orderDo&&item.orderDo.color||''
    item.unit=item.material&&item.material.unit||''
    return item
    })
  this.tableWarehouseData=res.data.data.items
  this.SearchPageInfo=res.data.data.page
    }
  }catch(error){
    console.log(error)
  }
}


  //扫码根据条码获取物料信息
  @action async getScanCodeDetail(type, params) {
    try {
      const url =
        type === 1
          ? services.requestUrl.getScanCodeDetail
          : services.requestUrl.getReturnsScanCodeDetail;
      let res = await services.getRequest(url, params);
      if (isDataExist(res)) {
        if (type == 1) {
          if (res.data.data.code == 1) {
            message.warning(res.data.data.msg);
          } else {
            this.packageCodeData = res.data.data.data;
            console.log(res.data.data.data);
          }
        } else {
          if (res.data.code == 1) {
            message.warning(res.data.msg);
          } else {
            this.packageCodeData = res.data.data;
            console.log(res.data.data);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  //获取表格数据
  @action.bound async getData(type, params) {
    this.isLoading = true;
    //1原材料入库列表
    const url =
      type === 1
        ? services.requestUrl.rawMaterialStockList
        : type === 2
          ? services.requestUrl.finishedProductStockList
          : type === 3
            ? services.requestUrl.returnsStockList
            : services.requestUrl.returnsStockList;
    try {
      let res = await services.getRequest(url, { ...params, ...this.PageTopInfo });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageTopInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取表格详情数据
  @action.bound async getDetailData(type, params) {
    this.isLoading = true;
    //1原材料入库列表  2:成品入库
    const url =
      type === 1
        ? services.requestUrl.getRawMaterialStockDetailList
        : type === 2
          ? services.requestUrl.finishedProductStockList
          : type === 3
            ? services.requestUrl.returnsStockList
            : services.requestUrl.productChangeList;
    try {
      let res = await services.getRequest(url, { ...params, ...this.PageInfo });
      this.isLoading = false;
      if (isDataExist(res)) {
        res.data.data.items&&res.data.data.items.map(item=>{
          item.supplierName=item.supplierName||item.supplier&&item.supplier.fullName||""
          item.clientName=item.client&&item.client.fullName||""
          item.planNo=item.plan&&item.plan.planNo||''
          item.code=item.material&&item.material.code||''
          item.name=item.material&&item.material.name||""
          item.unit=item.material&&item.material.unit||""
          item.weight=item.material&&item.material.weight||""
          item.color=item.order&&item.order.color||""
          item.locationNo=item.locationNo||item.warehouse&&item.warehouse.locationNo||''
          item.color=item.order&&item.order.color||""
          return item
        })
        this.tableDetailData = res.data.data.items||[];
        this.PageInfo = res.data.data.page;
        console.log('PageInfo',this.PageInfo)
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound async getPlanNo(params){
    const url=services.requestUrl.getByCodeByPlanNo
    try{
         let res=await services.getRequest(url,params)
         if(isDataExist(res)){
         this.planNoData=res.data.data
         }
    }catch(error){
      console.log(error)
    }
  }
  //保存信息
  @action.bound async saveData(type, params) {
    this.isLoading = true;
    //1原材料入库列表 2:成品入库
    const url =
      type === 1
        ? services.requestUrl.saveRawMaterialStock
        : type === 2
          ? services.requestUrl.saveFinishedProductStock
          : type === 3
            ? services.requestUrl.saveReturnsStock
            : services.requestUrl.saveProductChange;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  //打开/关闭模态框
  @action modalChange = (type, record) => {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    console.log(this.formData);
    console.log(this.packageCodeData);
    this.modalVisible = !this.modalVisible;
  };

  @action.bound showPrintTable(visible) {
    this.printModalVis = visible;
  }
  // 清除数据
  @action clearData() {
    this.tableData = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.PageTopInfo = { pageIndex: 1, pageSize: 10 };
    this.SearchPageInfo={pageIndex:1,pageSize:10};
    this.searchData = "";
    this.modalVisible = false;
    this.formData = {};
    this.packageCodeData = {};
    this.currentMaterial = "";
    this.currentSupplier = "";
    this.currentWarehouse = "";
    this.currentClient = "";
    this.type = 0;
    this.tableDetailData = [];

    this.searchMaterialId = "";
    this.searchMaterialName=''; //物料名称
    this.searchSupplierId = "";
    this.searchLocationNo = "";
    this.searchClientId = "";
    this.searchOrigin = "";
    this.searchStartDate = "";
    this.searchEndDate = "";
    this.pullBack = "";
    this.searchPlanNo = ""
    this.searchColor = ""
    this.planNo=''
    this.locationNo=''
    this.printModalVis = false; //打印页面展示
    this.printData = [];
    this.printSumData = "";
    this.MenuPermissions=[]  //菜单权限
    this.selectedRowKeys = [];
    this.selectedRows = [];
    this.tableWarehouseData=[] //成品入库页面信息
    this.businessType=''
    this.Tabs=''
    this.planNoData={}
  }
}

let StockStore = new Stock();
export default StockStore;
